import base from '../dr-base'
import itChart from './it-chart.vue'

const schema = {
  ...base,
  $Type: 'it-chart',
  name: 'Chart',
  group: 'Advanced',
  icon: 'chart-line',
  properties: {
    ...base.properties,
    Chart: {
      name: 'vuetifyWidgets.it-chart.chart',
      type: 'string'
    }
    // {
    //   type: 'object',
    //   properties: {
    //     ...base.properties,
    //     type: {
    //       type: 'string'
    //     },
    //     series: {
    //       type: 'array',
    //       items: {
    //         type: 'object',
    //         properties: {
    //           name: {
    //             type: 'string'
    //           },
    //           data: {
    //             type: 'array',
    //             items: {
    //               type: 'any'
    //             }
    //           }
    //         }
    //       }
    //     },
    //     options: {
    //       chart: {
    //         id: 'vuechart-example',
    //         locales: null,
    //         defaultLocale: null
    //       },
    //       xaxis: {
    //         categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
    //       }
    //     },
    //     width: {
    //       type: 'string'
    //     },
    //     height: {
    //       type: 'string'
    //     }
    //   }
    // }
  }
}

export default {
  schema,
  component: itChart
}
